export default {
  SET_WINDOW_DIMENSIONS: 'SET_WINDOW_DIMENSIONS'
}
